import { render } from "./BuilderSliderImages.vue?vue&type=template&id=4115f976&scoped=true&ts=true&lang=pug"
import script from "./BuilderSliderImages.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderSliderImages.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderSliderImages.vue?vue&type=style&index=0&id=4115f976&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4115f976"]])

export default __exports__